module.exports = __webpack_public_path__ + "img/chests.6d3e60a9.svg";